import Cookies from 'cookies-js'
import { Store } from 'redux'

import authActions from 'actions/auth'

import { get } from './cookieHelper2'

export function processOauthClientSide(cookies: typeof Cookies, store: Store) {
  const accessToken = get<{ access_token: string }>(cookies, 'oauth_token')?.access_token
  const expiresAt = get<{ expires_at: string }>(cookies, 'oauth_expiry')?.expires_at
  const refreshToken = get<{ refresh_token: string }>(cookies, 'oauth_refresh')?.refresh_token
  const rememberMe = get<{ remember_me: boolean }>(cookies, 'oauth_remember')?.remember_me

  if (accessToken || refreshToken) {
    store.dispatch(authActions.userAuthenticatedViaCookies(accessToken, refreshToken, expiresAt))
  }

  if (rememberMe !== undefined) {
    store.dispatch(authActions.userRememberMe(rememberMe))
  }
}
